(function () {

	angular
		.module('ngmvac')
		.controller('loginController', LoginController);

	LoginController.$inject = ['$scope', '$window', '$http', '$log'];

	function LoginController($scope, $window, $http, $log) {
		var vm = this;
		
		$.HSCore.components.HSValidation.init('.js-validate', {
            rules: {
                confirmPassword: {
                equalTo: '#signupPassword'
                }
            }
        });
    
        // initialization of forms
        $.HSCore.components.HSFocusState.init();
    
        // initialization of show animations
        $.HSCore.components.HSShowAnimation.init('.js-animation-link');

	}

})();
